export default "__VITE_ASSET__CF$z7_Pa__"